import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { isNotNullOrUndefined } from 'shared/utils/types'
import { EmailValidation } from 'shared/utils/validations'
import { SystemState } from './types'

export const getSendEmail = (state: SystemState) => state.sendMessage.email

export const getSendEmailId = (state: SystemState) =>
  state.sendMessage.email.messageId

export const getSendEmailRecipients = (state: SystemState) =>
  state.sendMessage.email.message?.recipients || []

export const getEmailReciept = (state: SystemState) =>
  state.sendMessage.email.reciept

export const getIsEmailCollapsed = (state: SystemState) =>
  state.sendMessage.email.isCollapsed

export const getEmailRecipientsWithInvalidCount =
  (recipientType: RecipientTypeEnum) => (state: SystemState) => {
    const allRecipients = getSendEmailRecipients(state)

    const recipients = allRecipients.filter(
      (recipient) => recipient.recipientType === recipientType
    )

    const invalidRecipients = recipients.filter(
      (recipient) => !EmailValidation.isValidSync(recipient.email)
    )

    const invalidOrDuplicate = recipients.filter((recipient) => {
      const { nameregisterId, email } = recipient

      const isDuplicate = allRecipients.some(
        (rec) =>
          ((isNotNullOrUndefined(rec.nameregisterId) &&
            isNotNullOrUndefined(nameregisterId) &&
            rec.nameregisterId === nameregisterId) ||
            (isNotNullOrUndefined(rec.email) &&
              isNotNullOrUndefined(email) &&
              rec.email === email)) &&
          rec?.recipientType !== recipientType
      )

      const isInvalid = invalidRecipients.some(
        (rec) =>
          rec.email === email ||
          (isNotNullOrUndefined(rec.nameregisterId) &&
            isNotNullOrUndefined(nameregisterId) &&
            rec.nameregisterId === nameregisterId)
      )
      return isInvalid || isDuplicate
    }).length

    return {
      recipients,
      invalidOrDuplicate,
    }
  }

export const getEmailRecipientsLoading = (state: SystemState) => {
  return getSendEmail(state).recipientLoadingQueue
}

export const isDraftUpdating = (state: SystemState): boolean => {
  return state.sendMessage.email.isDraftUpdating
}
